export const CHART_LIST_QUERY_KEY = 'chartList';
export const EXPORT_CHARTS_QUERY_KEY = 'exportCharts';
